import React, { Component } from "react";
import ReactPlayer from "react-player";
import styled from "styled-components";
import Titles from "../../components/Titles";

const PlayerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color:#0b152f;
  width: 100%;
  height: 100%;

  .playerDiv {
    height: 30%;
    width: 30%;
  }
`;

class Video extends Component {
  render() {
    return (
      <PlayerWrapper>
        <Titles
          {...{
            data: { title: "Sample NFT", subtitle: "" },
            color: "white",
            colorSub: "",
          }}
        />

        <div className="playerDiv">
          <ReactPlayer
            className="react-player fixed-bottom"
            url="https://rocknbones.s3.us-east-2.amazonaws.com/video.mp4?response-content-disposition=inline&X-Amz-Security-Token=IQoJb3JpZ2luX2VjELj%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEaDGV1LWNlbnRyYWwtMSJIMEYCIQD2A7lE4Z8T0qI1oe08ldgeiWCIxI3Uu%2FyIfRf4pcq%2BiAIhAOK7dMeuA6nrfv%2Bx9AtO1h5xRieR%2Fk%2FcUitRfiideyWzKv8CCLH%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQAhoMNzEwNTY4MDY4MTY3IgxoFw2g09ZAXeunZGsq0wKjTikewrS94qk0z68te1KjYuXAM5u%2BK%2FkImLd9rQtAgAzj9njZVlgYPi%2ByaSeY6SmGUCbQ5CjLvJdhyOP0TTTWG9uL3CC6L8NbOFq9WdIIv7F%2BQr2QGwlpP8M2IqVXogC3KYvtivHRD4gNOunhlMfRQo8qiqRkqxVqs%2FsMtuX2FTbFmaLxFSNq35wxWowkYKkXRDCkMnClxf1l48stX2%2F2gybzNurOvko9RlCXyvFdvF2Deb23f2wS90%2BwaahtiWKbGqR72VkKydGp0tKcqjHK%2B8uBn8yWav7A1QNyTLrB61S0%2BW01nR07sjYFUuKvfguzo2Go9O8lB1LWXN9DyjtSjP75ELvFRZKBTz3cuLa3lWGY0jvAhmqVdvctRPGQSMs%2BdIRKmcqW2a2yDEjx%2FhzzQLOrFEgP3VfwkVr8orpaoXVi7oY061mZC0GSs4%2ByVWw34Ggw27mojgY6sgIZYUmqUfuI5xL%2FMa3C7xw4InE9UuqiNzvbXu7AjH6w45atcyoC056J5myJbVf2QfajN0JU2wrZgQ51sZBCiYfkQRvVMWIIO4zq%2By%2BY%2BtREadIjw4g4m5wPiX1S4XgeS1rrP1WVpz8aR08h7LB3Ub%2BK8HwmzYeIV45W24lZwpxYSJxurwvbs38YzBBhGgmNpTU4WuEC1GlvG8nkaKGkiQYdInY4fxERCU3uQFMom1EGTnR%2Fv%2Fr2cGyTHKx%2FzPHtUM9j3AKvSJbHd1hFZXP1B0ddS1I4QAFtuVACdWw9BQewa2qg4YB2qDgShvZm5JlenZY86Pm91BRLIBvLwkUjQS5wi47CMevYqlAywNyEZ4zaDalqzE5e1wQp45600EMvfzYVOR0TyCYgI67qUzStI%2BN0AH0%3D&X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Date=20211227T235321Z&X-Amz-SignedHeaders=host&X-Amz-Expires=518400&X-Amz-Credential=ASIA2K4JIIRDTDIT5T4S%2F20211227%2Fus-east-2%2Fs3%2Faws4_request&X-Amz-Signature=b0b649785c1b4a6055971194a04d055c0dd4e317677da83fef5231d46ba4b1b2"
            width="100%"
            height="100%"
            controls={true}
          />
        </div>
      </PlayerWrapper>
    );
  }
}

export default Video;
